export default defineNuxtPlugin(() => {
  const router = useRouter();
  const routingHistoryStore = useRoutingHistoryStore();

  router.afterEach((to, from) => {
    if (to.path === from.path) {
      return;
    }

    routingHistoryStore.routeHistory.push(to.path);
  });
});
  